import { render, staticRenderFns } from "./CheckoutEmail.vue?vue&type=template&id=65aa9ef1"
import script from "./CheckoutEmail.vue?vue&type=script&lang=js"
export * from "./CheckoutEmail.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports